import { Mapper } from "lib/api"
import { Plant, PlantDTO, PlantDTOInner } from "models"

// first param is the DTO, second param is the class
export class PlantMapper extends Mapper<PlantDTO | PlantDTOInner, Plant> {
	constructor() {
		super(Plant) // Pass the target class constructor
	}
}

export function New(): PlantMapper {
	return new PlantMapper()
}
